<template>
  <div class="signStatus" v-if="isShow">
    <img @click="toSign" :src="img" alt="" />
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "signStatus",
  props: {
    year: {
      // 哪个年分，2023 夏季赛
      type: Number,
      default: 2023,
    },
    season: {
      // 哪个赛季 spring 春季，summer 夏季  autumn  冬季 winter
      type: String,
      default: "summer",
    },
    isShow: {
      // 是否显示
      type: Boolean,
      default: false,
    },
    isSign: {
      // 是否报名了
      type: Boolean,
      default: false,
    },
    registrationStatus: {
      type: Number | String,
      default: ''
    },
    registrationStatusTips: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      img: null,
    };
  },
  mounted() {
    let imgName = "signIcon.png";
    if (this.isSign) {
      imgName = "signSuccess.png";
    }
    this.img = require(`../../../assets/images/squirrelCup/2025/summer/${imgName}`);
  },
  methods: {
    toSign() {
      if (this.registrationStatus == 0 && !this.isSign) { // 产品配置下架了，直接弹出提示
        Toast(this.registrationStatusTips);
        return;
      }
      let url = '';
      if (this.year == '2023') {
        url = `/subpackages/home/squirrelCup/${this.year}/${this.season}/signUp/index`;
      } else {
        url = `/subpackages/home/squirrelCup/signUp/index?year=${this.year}&season=${this.season}`;
      }
      if (this.isSign) { // 报名成功，点击图片显示海报
        this.$emit('viewSignPoster');
      } else {
        wx.miniProgram.navigateTo({ url });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.signStatus {
  text-align: center;
  margin-bottom: 20px;
  img {
    width: 636px;
    height: 196px;
    position: relative;
    left:-10px;
  }
}
</style>
